import { gsap } from "gsap/all";
import { dl } from "../../src/js/core/app.js";
import { events, math, store } from "../../src/js/core/store.js";

export class Video {
  constructor(showGlobe = true) {
    this.open = document.querySelector(".js-open-manifest");
    if (!this.open) {
      return false;
    }
    this.showGlobe = showGlobe
    this.video = this.open.querySelector("video");
    this.src = this.video.getAttribute("data-src");
    this.back = this.open.querySelector(".js-close");
    this.icon = this.open.parentElement.querySelector(".js-icon");
    this.isOpen = false;
    this.previous = 0;
    this.current = 0;
    this.isTweening = false;
    this.globe = this.showGlobe ? document.querySelector(".js-globe") : document.querySelector('.js-before-after-header');
    this.init();
  }

  attach() {
    this.video.src = this.src;

    this.video.addEventListener("loadedmetadata", () => {
      this.tweenVideo();
      this.play();
    });
  }

  tweenVideo() {
    gsap.to(this.video, 2, {
      opacity: 1,
      ease: "power2.out",
    });
  }

  play() {
    this.video.play();

    this.videoInterval = setInterval(() => {
      if (this.video.currentTime > 4 && !this.isOpen) {
        this.video.currentTime = 0;
      }
    }, 50);
  }

  setStyles = () => {
    this.bounds = this.globe ? this.globe.getBoundingClientRect() : false;
    if (!this.bounds) {
      return false;
    }

    this.top = this.bounds.top;

    if (this.bounds.height < window.innerHeight) {
      this.top -= window.innerHeight - this.bounds.height;
    } else {
      this.top = window.innerHeight - (this.bounds.height + this.bounds.top);
      this.top *= -1;
    }

    this.open.style.height = `${window.innerHeight}px`;

    if (!this.isOpen) {
      const scaleWidth = window.innerWidth < 800 ? 140 / 860 : 140 / 1440;
      const scaleHeight = scaleWidth * (window.innerWidth / window.innerHeight);

      gsap.set(this.open, {
        scaleX: scaleWidth,
        scaleY: scaleHeight,
        opacity: 1,
      });

      gsap.set(this.video, {
        scaleX: 16 / 9,
      });
    }
  };

  toggle = () => {
    if (this.isTweening) {
      return false;
    }

    document.body.style.overflow = "hidden";
    this.isOpen = true;
    this.video.muted = false;
    this.open.style.zIndex = 100;
    this.back.style.pointerEvents = "all";

    this.bounds = this.globe ? this.globe.getBoundingClientRect() : false;
    if (!this.bounds) {
      return false;
    }

    this.top = this.bounds.top;

    if (this.bounds.height < window.innerHeight) {
      this.top -= window.innerHeight - this.bounds.height;
    } else {
      this.top = window.innerHeight - (this.bounds.height + this.bounds.top);
      this.top *= -1;
    }

    gsap.set(this.open, {
      y: this.top,
      left: 0,
      position: "fixed",
    });

    gsap.to(this.open, 1, {
      scale: 1,
      ease: "expo.out",
      borderRadius: 0,
      y: 0,
      onStart: () => {
        this.isTweening = true;
      },
      onComplete: () => {
        this.isTweening = false;
      },
    });

    gsap.to(this.icon, 0.1, {
      opacity: 0,
      ease: "power2.out",
    });

    gsap.to(this.video, 1, {
      scaleX: 1,
      ease: "expo.out",
    });

    gsap.to(this.back, 0.5, {
      opacity: 1,
      delay: 0.5,
      ease: "power2.out",
    });
  };

  close = () => {
    if (!this.isOpen || this.isTweening) {
      return false;
    }

    document.body.style.overflow = "unset";
    this.isOpen = false;
    this.video.muted = true;
    this.open.style.zIndex = 87;

    const scaleWidth = window.innerWidth < 800 ? 140 / 860 : 140 / 1440;
    const scaleHeight = scaleWidth * (window.innerWidth / window.innerHeight);

    this.back.style.pointerEvents = "none";
    this.back.style.opacity = 0;

    gsap.to(this.open, 0.5, {
      scaleX: scaleWidth,
      scaleY: scaleHeight,
      borderRadius: "100%",
      y: this.top,
      ease: "expo.out",
      onStart: () => {
        this.isTweening = true;
      },
      onComplete: () => {
        this.isTweening = false;

        gsap.set(this.open, {
          position: "absolute",
          y: 0,
        });
      },
    });

    gsap.to(this.video, 0.5, {
      scaleX: 16 / 9,
      ease: "expo.out",
    });

    gsap.to(this.icon, 0.2, {
      opacity: 1,
      delay: 0.3,
      ease: "power2.out",
    });
  };

  bindCloseButton() {
    this.back.addEventListener("mouseenter", () => {
      gsap.to(this.back, 0.5, {
        scale: 1.1,
        ease: "expo.out",
      });

      gsap.to(this.back.children, 0.5, {
        scaleX: 0.75,
        ease: "expo.out",
      });
    });

    this.back.addEventListener("mouseleave", () => {
      gsap.to(this.back, 0.5, {
        scale: 1,
        ease: "expo.out",
      });

      gsap.to(this.back.children, 0.5, {
        scaleX: 1,
        ease: "expo.out",
      });
    });

    this.back.addEventListener("click", (e) => {
      e.stopPropagation();
      this.close();
    });
  }

  init() {
    this.attach();
    this.setStyles();
    this.bindCloseButton();

    this.icon.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggle();
      dl.videoPlay();
    });

    this.open.addEventListener("click", (e) => {
      e.stopPropagation();
      this.toggle();
    });

    window.addEventListener("resize", this.setStyles);
    window.addEventListener("keydown", (e) => {
      if (e.keyCode === 27) {
        this.close();
      }
    });
  }
}
